import React, { useMemo } from 'react';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { usePPDLagoon } from '@sde/widgets-core/src/tools/lagoon';
import { styled } from '@uhg-abyss/web/tools/styled';
import { TabComponent } from '@sde/widgets-core/src/common/TabComponent';
import { RightRailSubCard } from '@src/common/RightRailSubCard';
import PropTypes from 'prop-types';
import { getDomain } from '../../../../../../../tools/getDomain';

const StyledBar = styled('div', {
  paddingBottom: '10px',
  borderBottom: '1px solid $gray4',
});

const StyledH2 = styled('h2', {
  fontFamily: 'AbyssUHCSerif, Georgia Bold, serif',
  color: '$primary1',
});

const HOME_PAGE_CONTENT_KEYS = [
  'REFERRALSTOOLRESOURCES',
  'REFERRALSINTERACTIVETRAININGGUIDE',
];

const REFERRALS_TAB_PROPS = {
  isReferralsTab: true,
  isReferralsSearch: true,
};
const ReferralsMainContents = ({
  user,
  payer,
  provider,
  payers,
  modals,
  modalData,
  dashboard,
  providerPreferenceComplete,
}) => {
  const domain = getDomain('sde-referrals', 3300);
  const props = {
    isReferralsTab: true,
    isReferralsSearch: true,
  };
  return (
    <React.Fragment>
      <StyledBar>
        <StyledH2>Referrals Search</StyledH2>
        <p>
          <b>What is a referral?</b> Referrals are the directing of a patient to
          a medical specialist by a primary care physician.
        </p>
      </StyledBar>
      <abyss-parcel
        import='referrals-search-widget@dev'
        label='Referrals Tab'
        props={JSON.stringify(REFERRALS_TAB_PROPS)}
        scriptdomain={domain}
        stretch
        showLoading
        loadingStyles={{ position: 'initial' }}
        user={JSON.stringify(user)}
        payer={JSON.stringify(payer)}
        provider={JSON.stringify(provider)}
        payers={JSON.stringify(payers)}
        modals={JSON.stringify(modals)}
        modalData={JSON.stringify(modalData)}
        dashboard={JSON.stringify(dashboard)}
        providerPreferenceComplete={JSON.stringify(providerPreferenceComplete)}
      />
    </React.Fragment>
  );
};
const ReferralsLinks = React.memo(({ user, toggleModal }) => {
  const { getHomePageContentsByArrayOfKeys } = usePPDLagoon();

  // Memoize referralLinks for efficiency
  const referralLinks = useMemo(
    () => getHomePageContentsByArrayOfKeys(HOME_PAGE_CONTENT_KEYS),
    [getHomePageContentsByArrayOfKeys]
  );

  return (
    <React.Fragment>
      <Flex
        style={{ height: '30%', padding: '0px 24px' }}
        direction='column'
        justify='space-evenly'
      >
        <RightRailSubCard
          railHeader='Referrals Resources'
          railLinks={referralLinks}
          user={user}
          toggleModal={toggleModal}
        />
      </Flex>
    </React.Fragment>
  );
});

export const referralsRightRail = (user, toggleModal) => [
  <ReferralsLinks user={user} toggleModal={toggleModal} />,
];

export const ReferralsTab = ({
  user,
  toggleModal,
  provider,
  payer,
  payers,
}) => (
  <TabComponent
    component={
      <ReferralsMainContents
        user={user}
        provider={provider}
        payer={payer}
        payers={payers}
      />
    }
    rightRails={referralsRightRail(user, toggleModal)}
    tabName='Referrals'
  />
);

ReferralsTab.propTypes = {
  user: PropTypes.objectOf(PropTypes.any).isRequired,
  toggleModal: PropTypes.func.isRequired,
};

ReferralsLinks.propTypes = {
  user: PropTypes.objectOf(PropTypes.any).isRequired,
  toggleModal: PropTypes.func.isRequired,
};
